<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button
              class="pull-right mb-1"
              v-if="getReverseInvoiceDashList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getAllBillingInvList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
            <b-button
              id="show-btn"
              size="xs"
              style="font-size: 0.675rem"
              class="ml-2"
              :variant="'info'"
              @click="addInv()"
            >
              Add Inv DOc
              <i class="fa fa-plus" aria-hidden="true"></i
            ></b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="6" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type to Search "
                        ref="search"
                      />
                      <b-input-group-append>
                        <!-- :disabled="!filter" -->
                        <b-button
                          @click="
                            filterClear();
                            clearFilter();
                          "
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <label for="blType">Date</label>
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    @update="debounceSearch"
                  ></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                  <!-- :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    " -->
                </b-col>
                <b-col md="3">
                  <label>Branch</label>

                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="BranchFilter"
                    v-model="Filter.BranchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="debounceSearch"
                  ></model-list-select>
                  <!-- :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    " -->
                </b-col>

                <b-col md="2"
                  ><h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5></b-col
                >
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="getReverseInvoiceDashList"
                  responsive
                  :fields="Columns"
                  primary-key="id_email_section"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  class="position-relative"
                >
                  <template slot="SN" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="InvNO" slot-scope="row1">
                    <b v-if="row1.item.inv_doc_folder_name && row1.item.inv_doc_url"
                      ><u>
                        <!-- <div
                          v-if="
                            invoiceDocDeatils.doc_path && invoiceDocDeatils.inv_doc_url
                          "
                        >
                          <span
                            v-for="(item1, index1) in invoiceDocDeatils.inv_doc_url.split(',')"
                            :key="index1"
                          >
                            <a
                              :style="
                                row1.item.inv_doc_folder_name && row1.item.inv_doc_url
                                  ? 'color: blue'
                                  : 'color: black'
                              "
                              :href="
                                `${docURL}/ASSIGNMENT_UPLOADS/` +
                                invoiceDocDeatils.doc_path +
                                '/' +
                                item1
                              "
                              target="_blank"
                              download
                              >Inv No : {{ row1.item.InvNO }} View {{ index1 + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                          </span>
                        </div> -->
                        <a
                          :style="
                            row1.item.inv_doc_folder_name && row1.item.inv_doc_url
                              ? 'color: blue'
                              : 'color: black'
                          "
                          href="javascript:void(0)"
                          @click="
                            row1.item.inv_doc_folder_name && row1.item.inv_doc_url
                              ? openSignedDocument(
                                  `ASSIGNMENT_UPLOADS/${row1.item.inv_doc_folder_name}/${row1.item.inv_doc_url}`
                                )
                              : ''
                          "
                          >Inv No : {{ row1.item.InvNO }}</a
                        >
                      </u>
                    </b>
                    <span v-else>Inv No : {{ row1.item.InvNO }}</span>
                    <br />
                    <span>Inv Date : {{ row1.item.InvDate }}</span
                    ><br />
                    <b-button
                      v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                      size="sm"
                      class="mt-2"
                      style="font-size: 0.675rem"
                      @click="showDocModal(row1.item)"
                      variant="outline-info"
                      >Summary & Documents</b-button
                    >
                    <InvExpSummary
                      v-if="row1.item.fk_all_module_id"
                      :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JOBNO"
                      :PMC_JOBID="row1.item.fk_all_module_id"
                      :PMC_JOBNO="row1.item.JOBNO"
                      :PMC_JOBDATE="row1.item.JOBDate | moment"
                      :PMC_JOBTYPE="row1.item.JobType"
                      :PMC_AgentType="''"
                      :PMC_Client="''"
                      :PMC_Sline="''"
                    />
                    <ContainerSummary
                      v-if="row1.item.fk_all_module_id"
                      :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO"
                      :PMC_JOBID="row1.item.fk_all_module_id"
                      :PMC_JOBNO="row1.item.JOBNO"
                      :PMC_JOBDATE="row1.item.JOBDate | moment"
                      :PMC_JOBTYPE="row1.item.JobType"
                      :PMC_AgentType="''"
                      :PMC_Client="''"
                      :PMC_Sline="''"
                    />
                    <JobWisePaymentsDetails
                  v-if="row1.item.fk_all_module_id"
                  :allModuleId="Number(row1.item.fk_all_module_id)"
                  :JobNo="row1.item.JOBNO"
                  />
                  </template>
                  <template slot="JOBNO" slot-scope="row1">
                    <span>Job No : {{ row1.item.JOBNO }}</span
                    ><br />
                    <span>Job Date : {{ row1.item.JOBDate }}</span>
                  </template>
                  <template slot="inv_doc_folder_name" slot-scope="row1">
                    <span v-if="row1.item.docSentBy"
                      >Sent By : {{ row1.item.docSentBy }}<br
                    /></span>
                    <span
                      v-if="
                        row1.item.inv_doc_sent_trough_email ||
                        row1.item.inv_doc_sent_trough_courier
                      "
                      >Invoice Sent Through :
                      {{
                        row1.item.inv_doc_sent_trough_email +
                        "/" +
                        row1.item.inv_doc_sent_trough_courier
                      }}<br
                    /></span>
                    <span v-if="row1.item.inv_doc_Docket_No"
                      >Docket No : {{ row1.item.inv_doc_Docket_No }}<br
                    /></span>
                    <span v-if="row1.item.inv_doc_date_courier">
                      Courier Date : {{ row1.item.inv_doc_date_courier }}<br
                    /></span>
                    <span v-if="row1.item.inv_doc_date">
                      Email Date : {{ row1.item.inv_doc_date }}<br
                    /></span>
                    <span v-if="row1.item.inv_doc_remark"
                      >Remarks : {{ row1.item.inv_doc_remark }}<br
                    /></span>
                    <!-- <div v-if="row1.item.inv_doc_folder_name && row1.item.inv_doc_url">
                    <span
                      v-for="(item1, index1) in row1.item.inv_doc_url.split(',')"
                      :key="index1"
                    >
                      <a
                        :href="
                          `${docURL}/ASSIGNMENT_UPLOADS/` +
                          row1.item.inv_doc_folder_name +
                          '/' +
                          item1
                        "
                        target="_blank"
                        download
                        >View {{ index1 + 1 }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                    </span>
                  </div> -->
                    <a
                      v-if="row1.item.inv_doc_folder_name && row1.item.inv_doc_url"
                      href="javascript:void(0)"
                      @click="
                        openSignedDocument(
                          `ASSIGNMENT_UPLOADS/${row1.item.inv_doc_folder_name}/${row1.item.inv_doc_url}`
                        )
                      "
                      >--View</a
                    >
                  </template>
                  <template slot="InvType" slot-scope="row2">
                    <b-button
                      variant="primary"
                      @click="uploadDoc(row2.item)"
                      id="uploadDoc"
                      >Upload Doc</b-button
                    >
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    @change="onPageChange($event)"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <b-modal
      id="rev_inv_doc_modal"
      ref="rev_inv_doc_modal"
      :title="'Upload Reverse Doc - ' + DocJOBNO + ' / Inv No : ' + DocInvNO"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col md="4">
          <label>
            <b> Sent By : </b>
          </label>
          <model-list-select
            :list="$store.getters['common/getAllUserList']"
            id="fk_inv_doc_sent_by"
            v-model="invoiceDocDeatils.fk_inv_doc_sent_by"
            option-value="userId"
            option-text="employeeName"
            placeholder="Select Created User"
          ></model-list-select>
        </b-col>
        <b-col md="4"
          ><label for="ColumnName">Invoice Sent Through :</label>
          <div class="checkbox-inline">
            <b-form-checkbox
              id="checkbox-Email"
              v-model="invoiceDocDeatils.inv_doc_sent_trough_email"
              name="checkbox-Email"
              value="Email"
              unchecked-value=""
            >
              Email
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox-Courier"
              v-model="invoiceDocDeatils.inv_doc_sent_trough_courier"
              name="checkbox-Courier"
              value="Courier"
              unchecked-value=""
            >
              Courier
            </b-form-checkbox>
          </div>
          <!-- <model-list-select
            :list="InvoiceTypeList"
            v-model="invoiceDocDeatils.inv_doc_sent_trough"
            class="mb-1"
            option-value="DVal"
            option-text="DText"
            placeholder="Select"
          ></model-list-select> -->
        </b-col>
        <b-col md="4" v-if="invoiceDocDeatils.inv_doc_sent_trough_email == 'Email'">
          <label for="ColumnName">Email Date :</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="amount"
            name="amount"
            v-model="invoiceDocDeatils.inv_doc_date"
            type="date"
          ></b-form-input>
        </b-col>
        <b-col md="4" v-if="invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier'">
          <label for="ColumnName">Docket No :</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="amount"
            name="amount"
            v-model="invoiceDocDeatils.inv_doc_Docket_No"
            type="text"
          ></b-form-input>
        </b-col>
        <b-col md="4" v-if="invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier'">
          <label for="ColumnName">Courier Date :</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="inv_doc_date_courier"
            name="inv_doc_date_courier"
            v-model="invoiceDocDeatils.inv_doc_date_courier"
            type="date"
          ></b-form-input>
        </b-col>

        <b-col md="4">
          <label for="ColumnName">Remarks :</label>
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="invoiceDocDeatils.inv_doc_remark"
            required
          ></b-form-textarea>
        </b-col>

        <b-col
          cols="12"
          v-if="invoiceDocDeatils.doc_path && invoiceDocDeatils.inv_doc_url"
        >
          <!-- <div v-if="invoiceDocDeatils.doc_path && invoiceDocDeatils.inv_doc_url">
           <span
             v-for="(item1, index1) in invoiceDocDeatils.inv_doc_url.split(',')"
             :key="index1"
           >
             <a
               :href="
                 `${docURL}/ASSIGNMENT_UPLOADS/` +
                 invoiceDocDeatils.doc_path +
                 '/' +
                 item1
               "
               target="_blank"
               download
               >View {{ index1 + 1 }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
           </span>
         </div> -->
        </b-col>
        <b-col md="12"
          ><label for="ColumnName">Doc :</label>
          <!-- <multi-file-uploader
            :style="`height: 79px;    background: darkgray;    width: 300px;`"
            :documentName="'ReverseTallyInv_Doc_'"
            :otherDocName="'ReverseTallyInv_Doc_'"
            :folderName="invoiceDocDeatils.JOBNO"
            :accept="'*'"
            :assign_no="invoiceDocDeatils.JOBNO ? invoiceDocDeatils.JOBNO : 'INVOICE'"
            :multiple="true"
            v-model="invoiceDocDeatils.inv_doc_url"
            :state="Boolean(invoiceDocDeatils.inv_doc_url)"
            :fileAllModuleId="invoiceDocDeatils.allModuleId"
          ></multi-file-uploader> -->
          <Single-Upload
            :index="0"
            :second_index="0"
            :multiple="false"
            :documentName="'ReverseTallyInv_Doc_'"
            :otherDocName="'ReverseTallyInv_Doc_'"
            :folderName="invoiceDocDeatils.JOBNO"
            :accept="'*'"
            v-model="invoiceDocDeatils.inv_doc_url"
            :state="Boolean(invoiceDocDeatils.inv_doc_url)"
            :assign_no="invoiceDocDeatils.JOBNO ? invoiceDocDeatils.JOBNO : 'INVOICE'"
            :fileAllModuleId="invoiceDocDeatils.allModuleId"
          />
          <span class="error" v-if="invoiceDocDeatils.inv_doc_url_err">{{
            invoiceDocDeatils.inv_doc_url_err
          }}</span>
          <a
            v-if="invoiceDocDeatils.doc_path && invoiceDocDeatils.inv_doc_url"
            href="javascript:void(0)"
            @click="
              openSignedDocument(
                `ASSIGNMENT_UPLOADS/${invoiceDocDeatils.doc_path}/${invoiceDocDeatils.inv_doc_url}`
              )
            "
            >--View</a
          >
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-md-12 text-center">
          <center>
            <b-button
              variant="success"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              @click="submitInvoiceDoc()"
              >Send</b-button
            >
            <b-button
              @click="hideRevInvDoc"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              variant="danger"
              >Close</b-button
            >
          </center>
        </div>
      </div>
    </b-modal>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import CommonService from "../../services/CommonService.js";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import SingleUpload from "../common/singleUpload.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
// import MultiFileUploader from "../common/MultiFileUploader.vue";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/billInvList");
      if (
        globalPermissionStatus("Pridel Document") ||
        globalPermissionStatus("Accounts")
      ) {
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getAllBillingInvList("Normal", "0", "0", "1", "1");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      ALLMODULE: "",
      JOBSERIES: "",
      DocJOBNO: "",
      DocInvNO: "",
      invoiceDocDeatils: {
        inv_doc_id: "",
        JOBNO: "",
        allModuleId: "",
        fk_all_module_id: "",
        fk_rev_tally_id: "",
        fk_tally_id: "",
        inv_doc_Common_ID: "",
        fk_inv_doc_sent_by: "",
        inv_doc_sent_trough_email: "",
        inv_doc_sent_trough_courier: "",
        inv_doc_Docket_No: "",
        inv_doc_date: "",
        inv_doc_date_courier: "",
        inv_doc_url: "",
        inv_doc_name: "",
        inv_doc_remark: "",
        doc_path: "",
        inv_doc_folder_name: "",
      },
      InvoiceTypeList: [
        {
          DVal: "1",
          DText: "Email",
        },
        {
          DVal: "2",
          DText: "Courier",
        },
      ],
      ExcelBtnName: "Export As Excel",
      isLoading: false,
      selectDateFormat,
      Filter: {
        clientIdFilter: "",
        BranchFilter:
          this.$sessionsStorage.get("designation") == "Admin"
            ? ""
            : this.$sessionsStorage.get("branch_baseLocation"),
        SlineFilter: "",
      },
      Columns: [
        {
          key: "SN",
          mainkey: "SN",
          label: "",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "InvNO",
          mainkey: "InvNO",
          label: "Inv No",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        // {
        //   key: "InvDate",
        //   mainkey: "InvDate",
        //   label: "Inv Date",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "JOB NO",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "inv_doc_folder_name",
          mainkey: "inv_doc_folder_name",
          label: "Doc Details",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "InvType",
          mainkey: "InvType",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        // {
        //   key: "JOBDate",
        //   mainkey: "JOBDate",
        //   label: "JOB Date",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "InvType",
        //   mainkey: "InvType",
        //   label: "Inv Type",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "E.",
        // },

        // {
        //   key: "InvBillngTypeStatusTxt",
        //   mainkey: "InvBillngTypeStatusTxt",
        //   label: "Billing Type",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "Status",
        //   mainkey: "Status",
        //   label: "Status",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "InvCreatedDate",
        //   mainkey: "InvCreatedDate",
        //   label: "Created AT",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "InvUpdatedDate",
        //   mainkey: "InvUpdatedDate",
        //   label: "Updated AT",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      getReverseInvoiceDashList: [],
      visible: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      visible: false,
      openLeft: "left",
      showCal: false,
      openRight: "right",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },

      adminToggle: this.$sessionsStorage.get("designation"),

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  // created() {
  //   eventBus.$on("fileuploaded", (file) => {
  //     console.log("fileuploaded=>", file);
  //     this.invoiceDocDeatils.inv_doc_url = file;
  //   });
  // },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      this.singleUpload = "";
      this.singleUpload = file;
    });
    eventBus.$on("fileuploadedsecondindex", (indexObj) => {
      console.log("fileuploadedsecondindex=>", indexObj);
      this.invoiceDocDeatils.inv_doc_url = this.singleUpload;
    });
  },
  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    CustomLoader,
    DateRangePicker,
    SingleUpload,
    DocForm,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    // MultiFileUploader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    submitInvoiceDoc() {
      this.invoiceDocDeatils.inv_doc_id =
        this.invoiceDocDeatils.inv_doc_id && !isNaN(this.invoiceDocDeatils.inv_doc_id)
          ? parseInt(this.invoiceDocDeatils.inv_doc_id)
          : 0;

      let payload = {
        itemCode: "upsertRevTallyDoc",
        invoiceDocDeatils: this.invoiceDocDeatils,
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.FLAG == 1) {
            this.alert.content = data.MSG;
            this.$refs["addPop"].open();
            this.hideRevInvDoc();
            this.getAllBillingInvList("Normal", "0", "0", "1", "1");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on submitInvoiceDoc Error: ", error);
        });
    },
    uploadDoc(item) {
      this.DocJOBNO = item.JOBNO;
      this.DocInvNO = item.InvNO;
      this.invoiceDocDeatils = {
        inv_doc_id: item.inv_doc_id,
        JOBNO: item.JOBNO,
        allModuleId: item.allModuleId,
        fk_all_module_id: item.fk_all_module_id,
        fk_rev_tally_id: item.fk_rev_tally_id,
        fk_tally_id: item.fk_tally_id,
        inv_doc_Common_ID: item.inv_doc_Common_ID,
        fk_inv_doc_sent_by: item.fk_inv_doc_sent_by,
        inv_doc_sent_trough_email: item.inv_doc_sent_trough_email,
        inv_doc_sent_trough_courier: item.inv_doc_sent_trough_courier,
        inv_doc_Docket_No: item.inv_doc_Docket_No,
        inv_doc_date: item.inv_doc_date,
        inv_doc_date_courier: item.inv_doc_date_courier,

        inv_doc_url: item.inv_doc_url,
        inv_doc_name: item.inv_doc_name,
        inv_doc_remark: item.inv_doc_remark,
        doc_path: item.JOBNO ? item.JOBNO.replaceAll("/", "_") : "INVOICE",
        inv_doc_folder_name: item.JOBNO ? item.JOBNO.replaceAll("/", "_") : "INVOICE",
      };
      console.log("item=>", item);
      this.$refs["rev_inv_doc_modal"].show();
    },
    hideRevInvDoc() {
      this.invoiceDocDeatils = {
        inv_doc_id: "",
        JOBNO: "",
        allModuleId: "",
        fk_all_module_id: "",
        fk_rev_tally_id: "",
        fk_tally_id: "",
        inv_doc_Common_ID: "",
        fk_inv_doc_sent_by: "",
        inv_doc_sent_trough_email: "",
        inv_doc_sent_trough_courier: "",
        inv_doc_Docket_No: "",
        inv_doc_date: "",
        inv_doc_date_courier: "",
        inv_doc_url: "",
        inv_doc_name: "",
        inv_doc_remark: "",
        doc_path: "",
        inv_doc_folder_name: "",
      };
      this.$refs["rev_inv_doc_modal"].hide();
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllBillingInvList("Excell", "0", "0", "1", "1");
    },
    getAllBillingInvList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      this.getReverseInvoiceDashList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      this.Filter.dateRange = this.dateRange;
      payload = {
        itemCode: "getReverseInvoiceDashList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        Filter: this.Filter,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.FLAG == 1) {
            this.totalRows = data.totalRows;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (type == "Excel") {
              if (data.getReverseInvoiceDashList.length > 0) {
                this.getReverseInvoiceDashList = data.getReverseInvoiceDashList;
              }
              this.ExcelBtnName = "Export As Excel";
              this.totalRows = data.totalRows;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getReverseInvoiceDashList.length > 0) {
                this.getReverseInvoiceDashList = data.getReverseInvoiceDashList;
                this.totalRows = data.totalRows;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getReverseInvoiceDashList Error: ", error);
        });
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.fk_all_module_id;
      this.JOBSERIES = item.JOBNO;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    goBack() {
      window.history.go(-1);
    },
    clearBranch() {
      this.Filter.BranchFilter = "";
    },
    clearFilter() {
      this.Filter = {
        clientIdFilter: "",
        BranchFilter: "",
        SlineFilter: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllBillingInvList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.getAllBillingInvList("Normal", "0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.getAllBillingInvList("Normal", "0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;
    },
    addInv() {
      this.$router.push({
        path: "/billInvList/multiInv",
      });
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.getAllBillingInvList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.checkbox-inline {
  display: inline-flex;
  align-items: center;
}

.checkbox-inline .form-check-input {
  margin-right: 5px; /* Adjust as needed */
}
</style>



// WEBPACK FOOTER //
// billingInvList.vue?1646965f